import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { helpers } from '#components/generics/js/styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const wrapper = closest(`.${helpers.xfiles.elements.xfiles_attach_draw_tools}`, button)

    if (wrapper) {
      const field = one('[type="hidden"][name="canvas_tool"]', wrapper)

      if (field) {
        field.value = button.name
      }
    }

    for (const btn of all('button', wrapper)) {
      if (btn === button) {
        button.classList.add(`${helpers.xfiles.modifiers.xfiles_attach_draw_tool.selected}`)
      } else {
        btn.classList.remove(`${helpers.xfiles.modifiers.xfiles_attach_draw_tool.selected}`)
      }
    }
  }
})

export default container => {
  for (const button of all('button', container)) {
    onClick.listen(button)
  }
}